import React from "react";
import "./permissionsSwitchbtn.css";

const PermissionsSwitchButton = ({ label, isActive = false, onToggle }) => {
  return (
    <div className="d-flex align-items-center gap20">
      <div
        className={`switch-button-permissions w40 ${isActive ? "active" : "inactive"}`}
        onClick={() => onToggle && onToggle(!isActive)}
      >
        <div className="switch-knob-permissions"></div>
      </div>
      <div>
        <p className="fs16 semibold darkGrey">{label}</p>
      </div>
    </div>
  );
};

export default PermissionsSwitchButton;
